import { MarkupTheme } from '@/components/Markup/theme';
import { tw } from '@/utils/tw';

const Prose = tw.theme({
  extend: MarkupTheme,
  base: 'prose',
});

export default Prose;
